import React, { useState } from "react";
import { Link } from "react-router-dom";
import { blogPosts, blogCategories } from "../blogData";
import Footer from "../components/heider/Footer";
import ContactForm from "../components/heider/ContactForm";
import useReveal from "../hooks/useReveal";
import { ArrowRight } from "lucide-react";

const BlogPage = () => {
  const [cat, setCat] = useState("All");
  useReveal(cat);
  const posts = cat === "All" ? blogPosts : blogPosts.filter((p) => p.category === cat);
  const [featured, ...rest] = posts;

  return (
    <div className="page-in">
      <section className="relative pt-40 pb-20 md:pt-48 md:pb-24 bg-[#0d0d0d] text-white overflow-hidden">
        <div className="absolute inset-0" style={{ background: "radial-gradient(80% 90% at 20% 10%, rgba(180,147,106,0.20), rgba(13,13,13,0) 60%)" }} />
        <div className="relative max-w-[1200px] mx-auto px-6 md:px-10">
          <p className="text-[11px] tracking-luxe uppercase text-[#b4936a] mb-5">The Journal</p>
          <h1 className="font-serif-display text-5xl md:text-7xl font-light leading-tight max-w-3xl">DMV Real Estate Insights</h1>
          <p className="text-white/55 text-[15px] leading-relaxed max-w-2xl mt-6">Neighborhood guides, market trends, and selling strategies for Washington DC, Maryland, and Northern Virginia — straight from the Capital Corner team.</p>
        </div>
      </section>

      <section className="bg-[#f3f1ec] py-16 md:py-24">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10">
          <div className="flex flex-wrap gap-2 mb-12" data-testid="blog-category-filter">
            {["All", ...blogCategories].map((c) => (
              <button
                key={c}
                data-testid={`blog-cat-${c.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setCat(c)}
                className={`px-5 py-2 rounded-full text-[11px] tracking-luxe uppercase transition-all duration-300 border ${cat === c ? "bg-[#1a1a1a] text-white border-[#1a1a1a]" : "bg-transparent text-[#1a1a1a] border-[#1a1a1a]/25 hover:border-[#b4936a] hover:text-[#b4936a]"}`}
              >
                {c}
              </button>
            ))}
          </div>

          {featured && (
            <Link to={`/blog/${featured.slug}`} data-testid="blog-featured" className="group grid md:grid-cols-2 gap-8 md:gap-12 items-center mb-20 reveal">
              <div className="aspect-[4/3] overflow-hidden bg-neutral-200">
                <img src={featured.cover} alt={featured.title} className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />
              </div>
              <div>
                <p className="text-[11px] tracking-luxe uppercase text-[#b4936a] mb-4">{featured.category} &middot; {featured.readTime}</p>
                <h2 className="font-serif-display text-3xl md:text-4xl font-light text-[#1a1a1a] group-hover:text-[#b4936a] transition-colors leading-tight">{featured.title}</h2>
                <p className="text-neutral-500 text-[15px] leading-relaxed mt-5">{featured.excerpt}</p>
                <span className="inline-flex items-center gap-2 mt-6 text-[11px] tracking-luxe uppercase text-[#1a1a1a] border-b border-[#1a1a1a] pb-1 group-hover:text-[#b4936a] group-hover:border-[#b4936a] transition-colors">Read Article <ArrowRight size={14} /></span>
              </div>
            </Link>
          )}

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-10">
            {rest.map((p) => (
              <Link key={p.slug} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group reveal-scale">
                <div className="aspect-[4/3] overflow-hidden bg-neutral-200 mb-5">
                  <img src={p.cover} alt={p.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />
                </div>
                <p className="text-[10px] tracking-luxe uppercase text-[#b4936a] mb-3">{p.category} &middot; {p.date}</p>
                <h3 className="font-serif-display text-2xl text-[#1a1a1a] group-hover:text-[#b4936a] transition-colors leading-snug">{p.title}</h3>
                <p className="text-neutral-500 text-[14px] leading-relaxed mt-3 line-clamp-3">{p.excerpt}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <ContactForm />
      <Footer />
    </div>
  );
};

export default BlogPage;
